import request from '@/utils/request'


/**
 * 查询店铺管理员
 */
export function fechListStoreAdmin(data) {
  return request({
    url: '/admin/super/queryAdmin',
    method: 'post',
    data: data
  })
}

/**
 * 创建一个管理员账号
 */
export function createNewStoreAdmin(data) {
  return request({
    url: '/admin/super/createNewStoreAdmin',
    method: 'post',
    data: data
  })
}

/**
 * 创建一个店铺
 */
export function addNewStore(data) {
  return request({
    url: '/admin/super/addNewStore',
    method: 'post',
    data: data
  })
}

/**
 * 设置店铺合作时间
 */
export function storeCooperation(data) {
  return request({
    url: '/admin/super/storecooperation',
    method: 'post',
    data: data
  })
}

/**
 * 删除一个店铺
 */
export function delStore(params) {
  return request({
    url: '/admin/super/delStore',
    method: 'get',
    params: params
  })
}

/**
 * 创建一个店铺
 */
export function createNewStore(data) {
  return request({
    url: '/admin/super/addNewStore',
    method: 'post',
    data: data
  })
}

/**
 * 修改店铺账号密码
 */
export function changeAdminPasswd(params) {
  return request({
    url: '/admin/super/changeAdminPasswd',
    method: 'get',
    params: params
  })
}

/**
 * 删除店铺账号
 */
export function delAdmin(params) {
  return request({
    url: '/admin/super/delStoreAdmin',
    method: 'get',
    params: params
  })
}


/**
 * 查询店铺
 */
export function fechListStore(data) {
  return request({
    url: '/admin/super/queryStore',
    method: 'post',
    data: data
  })
}

/**
 * 查询所有课程模板
 */
export function fechListLessonTemplate() {
  return request({
    url: '/admin/super/qlLessonTl',
    method: 'get',
    data: null
  })
}

/**
 * 删除课程模板
 */
export function delLessonTemplate(params) {
  return request({
    url: '/admin/super/delLessonTl',
    method: 'get',
    params: params
  })
}

/**
 * 添加课程模板
 */
export function createLessonTemplate(data) {
  return request({
    url: '/admin/super/createLessonTl',
    method: 'post',
    data: data
  })
}



/**
 * 查询店铺购买课程模板
 */
export function fechListStoreLesson(data) {
  return request({
    url: '/admin/super/qlStoreLesson',
    method: 'post',
    data: data
  })
}

/**
 * 为店铺添加课程模板
 */
export function createStoreLesson(data) {
  return request({
    url: '/admin/super/createStoreLesson',
    method: 'post',
    data: data
  })
}
/**
 * 修改店铺课程状态
 */
export function updateStoreLessonuStatu(params) {
  return request({
    url: '/admin/super/updateSLStatu',
    method: 'get',
    params: params
  })
}

/**
 * 禁用店铺课程
 */
export function prohibitStoreLesson(params) {
  return request({
    url: '/admin/super/prohibitSL',
    method: 'get',
    params: params
  })
}

/**
 * 启用店铺课程
 */
export function inuseStoreLesson(params) {
  return request({
    url: '/admin/super/inuseSL',
    method: 'get',
    params: params
  })
}

/**
 * 店铺续费课程模板
 */
export function renewalDaySL(params) {
  return request({
    url: '/admin/super/renewalDaySL',
    method: 'get',
    params: params
  })
}
/**
 * 修改课程模板价格
 */
export function changeLessontpPrice(params) {
  return request({
    url: '/admin/super/changeLessontpPrice',
    method: 'get',
    params: params
  })
}

/**
 * 给门店添加短信数量
 */
export function addStoreVccCounts(params) {
  return request({
    url: '/admin/super/addStoreVccCounts',
    method: 'get',
    params: params
  })
}

export function addOssSpace(params) {
  return request({
    url: '/admin/super/addOssSpace',
    method: 'get',
    params: params
  })
}

/**
 * 修改门店信息
 * @param data
 */
export function updateStoreFront(data) {
  return request({
    url: '/admin/super/updateStoreFront',
    method: 'post',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/api/superAdmin.js